const SITE_NAME = "鲁啊鲁";

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

/**
 * Update document title + description/keywords for a page.
 */
export function applySeo(options: {
  title: string;
  description?: string;
  keywords?: string;
}) {
  const { title, description, keywords } = options;
  document.title = title;
  upsertMeta("property", "og:title", title);
  upsertMeta("name", "twitter:title", title);
  if (description) {
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:description", description);
    upsertMeta("name", "twitter:description", description);
  }
  if (keywords) {
    upsertMeta("name", "keywords", keywords);
  }
}

export function applyHomeSeo() {
  applySeo({
    title: `${SITE_NAME} - 多元内容展示与资讯平台`,
    description:
      "鲁啊鲁致力于为用户提供丰富的资讯和内容覆盖多领域，包括文化、娱乐、生活等，方便用户全面了解鲁啊鲁品牌及相关信息。",
    keywords: "鲁啊鲁,品牌资讯,多元内容,文化资讯,娱乐资讯,生活信息,综合平台",
  });
}

export function applyCategorySeo(name: string, description: string, keywords: string) {
  applySeo({
    title: `${name} - ${SITE_NAME}`,
    description,
    keywords,
  });
}

export function applyArticleSeo(title: string, description: string, keywords: string) {
  applySeo({
    title: `${title} - ${SITE_NAME}`,
    description,
    keywords,
  });
}

export function applyPageSeo(title: string, description: string, keywords: string) {
  applySeo({ title, description, keywords });
}